import { useNavigate } from "react-router-dom";
import { useSubscription } from "../contexts/SubscriptionContext";
import { SparklesIcon } from "@heroicons/react/24/solid";

export default function SubscribeBanner({ msg }) {
  const navigate = useNavigate();
  const { isSubscribed } = useSubscription();
  const bannerText = msg || "Upgrade to a Pro subscription now for unlimited recipes, favourites and more.";

  console.log("subscriber check, result isSubscribed: ",isSubscribed);

  if (isSubscribed) return null;

  return (
    <div
      className="bg-gradient-to-r from-sage to-sage/80 text-white p-4 rounded-xl shadow-md flex items-center justify-between gap-4 hover:scale-[1.02] transition-transform cursor-pointer"
      onClick={() => navigate("/subscribe")}
    >
      <div className="flex items-center gap-3">
        <SparklesIcon className="w-6 h-6 text-white/90" />
        <div>
          <h2 className="text-base font-semibold">Unlock Unlimited Recipes</h2>
          <p className="text-sm text-white/90">
            { bannerText }
          </p>
        </div>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation(); // prevent parent onClick
          navigate("/subscribe");
        }}
        className="bg-white text-sage font-semibold px-4 py-2 rounded-lg text-sm hover:bg-white/90 transition"
      >
        Upgrade to Pro
      </button>
    </div>
  );
}
